import marks_apple_face_id from './marks-apple-face-id.svg';
import marks_apple_pay_badge from './marks-apple-pay-badge.svg';
import marks_apple_pay_logo from './marks-apple-pay-logo.svg';
import marks_apple_touch_id from './marks-apple-touch-id.svg';
import marks_google_pay_logo from './marks-google-pay-logo.svg';
import marks_paypal_logo from './marks-paypal-logo.svg';

export const V2_MARKS_ICONS: { [char: string]: string } = {
  marks_apple_face_id,
  marks_apple_pay_badge,
  marks_apple_pay_logo,
  marks_apple_touch_id,
  marks_google_pay_logo,
  marks_paypal_logo,
};

export const V2_MARKS_ICON_NAMES: string[] = Object.keys(V2_MARKS_ICONS);
